module.exports = __webpack_public_path__ + "static/media/find-campaign-icon.bee102a4.svg";